export enum UploadItemKind {
  File = 'file',
  FileSet = 'fileSet',
}
